import { FDealType, FOfferType, isAvailable } from '../../../../JsonQuery';
import { SpecialOffersContainer } from '../../containers/advancedFilters/SpecialOffersContainer';
import { IFilter } from '../../types/advancedFilters';

export const specialOffers: IFilter = {
  component: SpecialOffersContainer,
  // Новостроечная и смешанная выдача.
  availability: ({ jsonQuery }) => isAvailable(FDealType.Sale, FOfferType.FlatNew)(jsonQuery),
};
